export function getInitialFormValuesFromApiValue(file, fileUrlPrefix) {
  return {
    uploadId: null,
    originalFilename: file ? file.originalFilename : null,
    uploading: false,
    uploaded: file ? !!file.originalFilename : false,
    fileUrl: file?.filename ? `${fileUrlPrefix}/${file.filename}` : null,
  };
}

export function getCommandFromFormValues(formValues) {
  if (!formValues?.originalFilename) {
    return null;
  }

  return {
    originalFilename: formValues.originalFilename,
    uploadId: formValues.uploadId,
  };
}
